import { initElements } from '../../define/shared';

export default function initHeroWithModalBlocks() {
    initElements('.hero-with-modal', root => {
        const openDialogBtn = root.querySelector(".openDialogButton");
        const dialogEl = root.querySelector("dialog");
        const closeDialogBtn = dialogEl?.querySelector(".closeDialogButton");

        openDialogBtn?.addEventListener('click', () => {
            dialogEl?.showModal();
        });

        closeDialogBtn?.addEventListener('click', () => {
            dialogEl?.close();
        });
    });
}
